import script from "./Unpaid.vue?vue&type=script&lang=ts&setup=true"
export * from "./Unpaid.vue?vue&type=script&lang=ts&setup=true"

import "./Unpaid.vue?vue&type=style&index=0&id=6f4cd92c&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f4cd92c"]])

export default __exports__